import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-feb4403e"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "top-container searchTop"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "search-left"
}, null, -1));
const _hoisted_4 = {
  key: 0,
  class: "button-container"
};
const _hoisted_5 = {
  class: "dialog-footer"
};
import { getData1, addData1, updateData1 } from "@/api/system1/data";
import { ref, unref, reactive, onMounted } from "vue";
import { ElMessageBox, ElMessage } from 'element-plus';
import { useStore } from "vuex";
export default {
  __name: 'data2',
  setup(__props) {
    const form = ref(null);
    const store = useStore();
    // 获取用户类型
    const userType = store.state.common.userInfo.userType;
    // 获取当前租户下拉
    const tenantInfos = store.state.common.userInfo.tenantInfos;
    const state = reactive({
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 用户表格数据
      list: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 是否显示弹出层（数据权限）
      openDataScope: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10
      },
      // 表单参数
      form: {
        tenantId: 3,
        totalUsers: '',
        valveWellCount: '',
        pressureBoxCount: '',
        pressureCabinetCount: '',
        cityGasCompanyCount: '',
        gasStationCount: ''
      },
      // 表单校验
      rules: {
        totalUsers: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        tenantId: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        valveWellCount: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        pressureBoxCount: [{
          required: true,
          message: "低压不能为空",
          trigger: "blur"
        }],
        pressureCabinetCount: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        cityGasCompanyCount: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }],
        gasStationCount: [{
          required: true,
          message: "不能为空",
          trigger: "blur"
        }]
      },
      saveLoading: false,
      saveLoading1: false,
      publicKey: '',
      //列表顶部顶部操作按钮数据
      buttonsList: [{
        buttonName: "新增",
        buttonStyle: "primary",
        hasPermi: ['sys:user:add'],
        className: 'addBtn',
        buttonIcon: "Plus",
        exp: item => handleAdd(item)
      }],
      tableHeader: [{
        prop: "totalUsers",
        label: "总用户数",
        isShow: true
      }, {
        prop: "valveWellCount",
        label: "阀井总数",
        isShow: true
      }, {
        prop: "pressureBoxCount",
        label: "调压箱总数",
        isShow: true
      }, {
        prop: "pressureCabinetCount",
        label: "调压柜总数",
        isShow: true
      }, {
        prop: "cityGasCompanyCount",
        label: "燃气企业",
        isShow: true
      }, {
        prop: "gasStationCount",
        label: "加气站总数",
        isShow: true
      }, {
        prop: "operation",
        label: "操作",
        width: "100px",
        fixed: "right",
        isShow: true,
        operation: [{
          name: '修改',
          clickFun: row => handleUpdate(row),
          hasPermi: []
        }]
      }],
      formScopeData: [
      // {
      //   prop: "tenantId",
      //   label: "所属租户",
      //   placeholder: "请选择所属租户",
      //   span: 24,
      //   type: "list",
      //   multiple:false,
      //   isSelect: false,
      //   options: tenantInfos,
      //   props: { label: "tenantName", value: "tenantId" },
      //   change: () => { },
      //   span: 24,
      //   hideHandle() {
      //     return userType !=2;//平台创普通用户展示租户下拉
      //   }
      // },
      {
        prop: "totalUsers",
        label: "总用户数",
        placeholder: "请输入总用户数",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "valveWellCount",
        label: "阀井总数",
        placeholder: "请输入阀井总数",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "pressureBoxCount",
        label: "调压箱总数",
        placeholder: "请输入调压箱总数",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "pressureCabinetCount",
        label: "调压柜总数",
        placeholder: "请输入调压柜总数",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "cityGasCompanyCount",
        label: "燃气企业",
        placeholder: "请输入燃气企业",
        type: "text",
        isSelect: false,
        span: 24
      }, {
        prop: "gasStationCount",
        label: "加气站总数",
        placeholder: "请输入加气站总数",
        type: "text",
        isSelect: false,
        span: 24
      }]
    });
    onMounted(() => {});
    /** 查询用户列表 */
    const getList = function () {
      state.loading = true;
      getData1(state.queryParams).then(response => {
        state.list = {
          rows: [response.data],
          total: 1
        };
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    };
    // 取消按钮（数据权限）
    const cancelDataScope = function () {
      state.openDataScope = false;
      state.form = {
        tenantId: 3,
        totalUsers: '',
        valveWellCount: '',
        pressureBoxCount: '',
        pressureCabinetCount: '',
        cityGasCompanyCount: '',
        gasStationCount: ''
      };
    };
    // 表单重置
    const reset = function () {
      state.form = {
        tenantId: 3,
        totalUsers: '',
        valveWellCount: '',
        pressureBoxCount: '',
        pressureCabinetCount: '',
        cityGasCompanyCount: '',
        gasStationCount: ''
      };
    };
    /** 搜索按钮操作 */
    const handleQuery = function () {
      state.queryParams.pageNum = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = function () {
      state.queryParams = {
        pageNum: 1,
        pageSize: 10
      };
      handleQuery();
    };
    /** 新增按钮操作 */
    const handleAdd = function () {
      state.openDataScope = true;
      state.title = "管网信息";
      reset();
    };
    /** 修改按钮操作 */
    const handleUpdate = function (row) {
      state.openDataScope = true;
      state.title = "修改数据";
      state.form = {
        ...row
      };
    };
    /** 修改/新增用户提交按钮*/
    const submitDataScope = function () {
      const formRef = unref(form);
      formRef.commonForm.validate(valid => {
        if (valid) {
          state.saveLoading = true;
          let params = {
            ...state.form
          };
          console.log(state.form, 'state.form--');
          if (state.form.id) {
            updateData1(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("修改成功");
                state.openDataScope = false;
                getList();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          } else {
            addData1(params).then(response => {
              if (response.code == 0) {
                ElMessage.success("新增成功");
                state.openDataScope = false;
                //新增后重置
                resetQuery();
              } else {
                ElMessage.error(response.msg);
              }
              state.saveLoading = false;
            }).catch(() => {
              state.saveLoading = false;
            });
          }
        }
      });
    };
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, state.buttonsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.buttonsList, (item, index) => {
        return _withDirectives((_openBlock(), _createBlock(_component_el_button, {
          key: index,
          class: _normalizeClass([item.className, item.buttonIcon]),
          loading: item.loading,
          icon: item.buttonIcon,
          type: item.buttonStyle,
          disabled: item.disabledHandle?.(item.prop, form.value),
          onClick: $event => item.exp(item)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.buttonName), 1)]),
          _: 2
        }, 1032, ["class", "loading", "icon", "type", "disabled", "onClick"])), [[_directive_hasPermi, item.hasPermi ? item.hasPermi : []]]);
      }), 128))])) : _createCommentVNode("", true)]), _withDirectives(_createVNode(_component_commonTable, {
        class: "flex-table",
        tableData: state.list,
        tableHeader: state.tableHeader,
        queryParams: state.queryParams,
        onGetList: getList,
        hasSelect: false,
        columnSetting: false
      }, null, 8, ["tableData", "tableHeader", "queryParams"]), [[_directive_loading, state.loading]]), _createVNode(_component_commonDrawer, {
        modelValue: state.openDataScope,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => state.openDataScope = $event),
        size: "600px",
        title: state.title,
        "close-on-click-modal": false,
        onClose: cancelDataScope
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createVNode(_component_el_button, {
          type: "primary",
          onClick: submitDataScope,
          loading: _ctx.saveLoading
        }, {
          default: _withCtx(() => [_createTextVNode("确 定")]),
          _: 1
        }, 8, ["loading"]), _createVNode(_component_el_button, {
          onClick: cancelDataScope
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_commonForm, {
          ref_key: "form",
          ref: form,
          form: state.form,
          formRules: state.rules,
          formData: state.formScopeData,
          isHandle: false
        }, null, 8, ["form", "formRules", "formData"])]),
        _: 1
      }, 8, ["modelValue", "title"])]);
    };
  }
};